import {useContext} from 'react';
import {useParams, useRouteMatch} from 'react-router-dom';
import {InviteSenderType} from '../../../../../../../backend/enums/invite-sender-type';
import {InformalCaregiverInviteForm} from '../../../../../../../components/informal-caregiver-invite-form/informal-caregiver-invite-form';
import {AuthContext} from '../../../../../../../contexts/auth/context';
import {AuthContextType} from '../../../../../../../contexts/auth/types';
import {OfficeContext} from '../../../../../../../contexts/office/context';
import {OfficeContextType} from '../../../../../../../contexts/office/types';

export default function SeniorInviteInformalCaregiverSystemAdministratorOfficeScreen() {
  // Get context
  const authContext: AuthContextType = useContext(AuthContext);
  const officeContext: OfficeContextType = useContext(OfficeContext);

  // Get params
  let {id}: {id?: string} = useParams();

  // The `path` lets us build <Route> paths that are
  // relative to the parent route, while the `url` lets
  // us build relative links.
  let {url} = useRouteMatch();

  return (
    <InformalCaregiverInviteForm
      seniorId={id || ''}
      seniorName={officeContext.state.userForm?.user.name || ''}
      senderType={InviteSenderType.System}
      senderId={authContext.state.session?.id || ''}
      redirectUrl={url.replace('/invite', '/invites')}
    />
  );
}
